import React, { useCallback, useReducer } from "react";
import { SetItemReducer, SET_ITEM, DELETE_ITEM } from "reducers/SetItemReducer";
import uuid from "uuid/v1";
import { Embedded, Preview } from "components";
import { NotifyProvider } from "context/NotifyContext";

export const isEmbedded =
  ({
    ChildComponent,
    previewOpenByDefault = true,
    noCampaign = false,
    newPlanRedirect,
    setIsOpen,
  }) =>
  () => {
    const [state, dispatch] = useReducer(SetItemReducer, {});

    const createNotification = (notification) => {
      const id = notification.id || uuid();
      if (!state[id])
        dispatch({ type: SET_ITEM, path: id, value: { id, ...notification } });
    };
    const deleteNotification = (id) =>
      dispatch({ type: DELETE_ITEM, path: id });

    return (
      <NotifyProvider value={{ state, createNotification, deleteNotification }}>
        <Embedded newPlanRedirect={newPlanRedirect}>
          <Preview openByDefault={previewOpenByDefault} noCampaign={noCampaign}>
            {ChildComponent && <ChildComponent setIsOpen={setIsOpen} />}
          </Preview>
        </Embedded>
      </NotifyProvider>
    );
  };

export const hasPreview = (
  ChildComponent,
  openByDefault = true,
  noCampaign = false
) => {
  return () => (
    <Preview openByDefault={openByDefault} noCampaign={noCampaign}>
      <ChildComponent />
    </Preview>
  );
};
